import React from 'react';
import PropTypes from 'prop-types';
import { Divider, ProgressBar } from '@adobe/react-spectrum';
import Avatar from '@material-ui/core/Avatar';
import { Tooltip } from '@material-ui/core';
import { AiOutlineSelect } from 'react-icons/ai';

import moment from 'moment';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import { getLocalDateTime } from '../../utils/utils';

import {
  Header,
  Circle,
  Assignee,
  Status,
  PlannedCompletionDate,
  HeaderTop,
  HeaderBottom,
  TaskName,
  TaskExternalLink,
  TaskBreadcrumb,
  TaskBreadcrumbdiv,
} from './styles';

const { getStatusColorAndLabel } = require('../../utils/utils');

const TaskDetailsHeader = props => {
  const { task, taskBreadCrumb, breadcrumbTooltip } = props;

  async function editTaskProperties(
    enteredDate,
    enteredPercent,
    enteredStatus,
  ) {
    const queryParams = {
      ID: task.ID,
      taskConstraint: 'MFO',
      constraintDate: enteredDate,
      plannedCompletionDate: enteredDate,
      percentComplete: enteredPercent,
      status: enteredStatus,
      method: 'PUT',
    };
    await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK, queryParams },
    );
  }

  return (
    <>
      <Header>
        {taskBreadCrumb && breadcrumbTooltip && (
          <Tooltip arrow placement="top" title={breadcrumbTooltip}>
            <TaskBreadcrumbdiv>
              <TaskBreadcrumb> {taskBreadCrumb[0].label} </TaskBreadcrumb>/{' '}
              <TaskBreadcrumb> {taskBreadCrumb[1].label} </TaskBreadcrumb>/{' '}
              {taskBreadCrumb[2].label}
            </TaskBreadcrumbdiv>
          </Tooltip>
        )}
        <HeaderTop>
          <Avatar
            variant="circular"
            style={{ height: '50px', width: '50px' }}
            alt="Nike logo"
            src="https://thumbs.dreamstime.com/b/fundo-preto-vetor-do-logotipo-nike-da-marca-para-uso-impresso-de-vestu%C3%A1rio-desportivo-e-gin%C3%A1stica-183282388.jpg"
          />
          <TaskName>{task.name}</TaskName>
          <TaskExternalLink>
            <AiOutlineSelect
              size={14}
              style={{ transform: [{ rotateX: '180deg' }] }}
            />
            <span>Take me to...</span>
          </TaskExternalLink>
        </HeaderTop>
        <HeaderBottom>
          <ProgressBar
            UNSAFE_className="spaceBarFromLabel"
            label="Percent Complete"
            value={task.percentComplete}
          />

          <PlannedCompletionDate>
            <section>Planned Completion</section>
            <span>
              {moment(
                new Date(getLocalDateTime(task.plannedCompletionDate)),
              ).format('ll')}
            </span>
          </PlannedCompletionDate>

          <Status>
            <section>Status</section>
            <div>
              <Circle
                color={getStatusColorAndLabel(task.status, task.allStatuses)[0]}
              />
              <span>
                {getStatusColorAndLabel(task.status, task.allStatuses)[1]}
              </span>
            </div>
          </Status>
          <Assignee>
            <section>Assigned to</section>
            <div>
              <Avatar
                variant="circular"
                style={{ height: '26px', width: '26px' }}
                alt="Nike logo"
                src="https://thumbs.dreamstime.com/b/fundo-preto-vetor-do-logotipo-nike-da-marca-para-uso-impresso-de-vestu%C3%A1rio-desportivo-e-gin%C3%A1stica-183282388.jpg"
              />
              <span>{task.assignmentsListString}</span>
            </div>
          </Assignee>
        </HeaderBottom>
      </Header>
      <Divider size="S" marginX={45} />
    </>
  );
};
TaskDetailsHeader.propTypes = {
  task: PropTypes.arrayOf,
  taskBreadCrumb: PropTypes.arrayOf,
  breadcrumbTooltip: PropTypes.string,
};

TaskDetailsHeader.defaultProps = {
  task: '',
  taskBreadCrumb: [],
  breadcrumbTooltip: ' ',
};
export default TaskDetailsHeader;
